import { useState } from "react";
import { LuMailOpen, LuArrowLeft, LuDownload, LuTrash2, LuPrinter, LuMoreVertical, LuPencil } from "react-icons/lu";
import { GoMail } from "react-icons/go";

function getReplies(mailLibId, list) {
  if (!Array.isArray(list)) return [];

  const mail = list.find(item => item.mailLibId === mailLibId);
  return mail?.replyList || [];
}
function getEmployeeName(emp) {
  return emp && emp.name ? emp.name : "Unknown";
}

function getInitials(name) {
  if (!name) return "";

  const words = name.trim().split(" ");
  return words.length === 1
    ? words[0][0].toUpperCase()
    : (words[0][0] + words[1][0]).toUpperCase();
}



export const EmailsContent = ({ userDetails, statusData, openPrintModal }) => {
  // console.log("statusData---->statusData---->", statusData)
  const inboxData =
    statusData?.mailIdList?.length > 0
      ? statusData.mailIdList.map((mail) => ({
        id: mail.id,

        senderName: mail.senderName,
        senderEmail: mail.senderEmail,

        recipientName: mail.recipientName,
        recipientEmail: mail.recipientEmail,

        subject: mail.subject,
        body: mail.body,

        initials: mail.senderName?.charAt(0) || "U",
        date: new Date(mail.createdAt).toLocaleDateString(),
        time: new Date(mail.createdAt).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
        fullDate: new Date(mail.createdAt).toDateString(),
        replies: getReplies(mail.id, statusData.mailReplyList || []).map((r) => ({
          id: r.id,
          repliedBy: "Replied By " + getEmployeeName(statusData.employeeId),
          initials: getInitials(getEmployeeName(statusData.employeeId)),
          message: r.body,
          date: new Date(r.createdAt).toDateString(),
          time: new Date(r.createdAt).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
        }))
      }))
      : [];


  const [selectedId, setSelectedId] = useState(inboxData[0]?.id);
  const [showMobileDetail, setShowMobileDetail] = useState(false);
  const [activeMenuId, setActiveMenuId] = useState(null);

  const toggleMenu = (e, id) => {
    e.stopPropagation();
    setActiveMenuId(prev => (prev === id ? null : id));
  };

  const activeMail =
    inboxData.find(m => m.id === selectedId) || inboxData[0];

  // ✅ EMPTY STATE
  if (!inboxData.length) {
    return (
      <div className="w-full flex items-center justify-center min-h-[300px] px-4 py-6">
        <p className="text-gray-500 text-sm md:text-base text-center">
          No mail assigned!
        </p>
      </div>
    );
  }

  return (
    <>
      <div className="flex h-full min-h-0 overflow-hidden pb-24">

        {/* SIDEBAR */}
        <aside
          className={`w-full lg:w-[400px] border-r border-gray-300 
    overflow-y-auto min-h-0 ${showMobileDetail ? "hidden lg:block" : "block"
            }`}
        >
          <div className="p-3">
            <button onClick={() => openPrintModal()} className="w-full flex items-center font-medium justify-center gap-2 px-3 py-3 border border-gray-300 rounded-md text-sm hover:bg-gray-50">
              <LuDownload size={20} /> Download All Mails
            </button>
          </div>

          {inboxData?.length ? (
            inboxData.map((item) => (
              <>
                <div
                  key={item.id}
                  onClick={() => {
                    setSelectedId(item.id);
                    setShowMobileDetail(true);
                  }}
                  className={`p-3 border-b border-gray-300 cursor-pointer flex gap-3 ${selectedId === item.id
                    ? "bg-indigo-100"
                    : "hover:bg-gray-50"
                    }`}
                >
                  <div className="mt-1">
                    {item.unread ? <GoMail size={20} /> : <LuMailOpen size={20} />}
                  </div>

                  <div className="flex-1 min-w-0">
                    <div className="flex justify-between">
                      <h3 className="md:text-lg text-base font-medium truncate">
                        {item.senderName}
                      </h3>
                      <span className="text-sm text-gray-900">
                        {item.date}
                      </span>
                    </div>

                    <p className="text-sm text-gray-600 truncate">
                      {item.subject}
                    </p>
                  </div>
                </div>
              </>
            ))
          ) : (
            <div className="flex items-center justify-center h-full">
              <p className="text-gray-900 text-lg">Data not available!</p>
            </div>
          )}
        </aside>

        {/* RIGHT PANEL */}
        <main
          className={`flex-1 overflow-y-auto min-h-0 bg-white ${!showMobileDetail ? "hidden lg:block" : "block"
            }`}
        >
          <div className="p-4 md:p-6">

            <div className="flex items-center gap-4 shrink-0 mb-6">
              <button className="p-2 rounded-full bg-indigo-100 text-indigo-600 lg:hidden block" onClick={() => setShowMobileDetail(false)}>
                <LuArrowLeft size={22} />
              </button>
              <h1 className="text-lg md:text-xl font-semibold text-gray-800">{activeMail.subject}</h1>
            </div>

            {/* META */}
            <p className="text-sm md:text-base mb-4">
              <b>From:</b> {activeMail.senderName} ({activeMail.senderEmail})
              <br />
              <b>To:</b> {activeMail.recipientName} ({activeMail.recipientEmail})
            </p>

            {/* BODY */}
            <div
              className="mb-6 md:text-base text-sm leading-relaxed"
              dangerouslySetInnerHTML={{ __html: activeMail.body }}
            />

            {(activeMail.replies?.length || 0) > 0 ?
              <>
                {/* REPLIES */}
                <h3 className="font-semibold md:text-lg mb-3">
                  Replies ({activeMail.replies?.length || 0})
                </h3>

                {activeMail.replies?.map((reply) => (
                  <div key={reply.id} className="border-b py-3 relative">

                    <div className="flex justify-between">
                      <p className="font-medium md:text-base text-sm">
                        {reply.repliedBy}
                      </p>
                      <button onClick={(e) => toggleMenu(e, reply.id)}>
                        <LuMoreVertical />
                      </button>
                    </div>

                    <div
                      className="mt-2 md:text-base text-sm"
                      dangerouslySetInnerHTML={{ __html: reply.message }}
                    />

                    {activeMenuId === reply.id && (
                      <div className="absolute right-0 top-6 bg-white shadow rounded z-10">
                        <button className="flex gap-2 px-4 py-2 text-sm w-full">
                          <LuPencil /> Edit
                        </button>
                        <button className="flex gap-2 px-4 py-2 text-sm text-red-500 w-full">
                          <LuTrash2 /> Delete
                        </button>
                      </div>
                    )}

                  </div>
                ))}
              </>
              :
              <div className="flex items-center justify-center h-64">
                <p className="text-gray-800 text-3xl">Replies not available!</p>
              </div>

            }





          </div>
        </main>
      </div>
    </>
  );
};